export const ReferralType = Object.freeze({
    PENDING: "PENDING",
    REFERRED: "REFERRED",
});
